import Image from 'next/image';
import { Dispatch, SetStateAction } from 'react';

import { Button } from '../../../ui';

export const Introduction = ({
  setCurrentStep,
  isLoading,
}: {
  setCurrentStep: Dispatch<
    SetStateAction<
      | 'REQUIREMENTS'
      | 'INTRODUCTION'
      | 'CAPITAL TYPES'
      | 'GROWTH PLAN'
      | 'FINANCIALS'
      | 'OWNERSHIP'
      | 'EBITDA'
      | 'AMOUNT NEEDED'
      | 'BREAKDOWN'
      | 'REVIEW'
      | 'CONFIRMATION'
    >
  >;
  isLoading: boolean;
}) => {
  return (
    <div className="flex gap-8">
      <div className="flex flex-col gap-4 flex-1">
        <div className="flex flex-col gap-2">
          <span className="text-2xl font-bold">
            Describe Your Financial Needs
          </span>
          <span className="text-base font-normal">
            Please provide details about your financial requirements. This will
            help us better understand your needs and tailor our assistance
            accordingly. Add as many details as possible.
          </span>
        </div>
        <textarea
          className="rounded-2xl bg-gray-100 resize-none p-3 sm:min-h-[150px] md:min-h-[250px] lg:min-h-[375px]"
          placeholder="Enter financial needs..."
        ></textarea>
        <div className="flex gap-3">
          <div>
            <Button
              text="Back"
              variant={isLoading ? 'disabled' : 'secondary'}
              onClick={() => setCurrentStep('REQUIREMENTS')}
            />
          </div>
          <div>
            <Button
              text="Continue"
              variant={isLoading ? 'disabled' : 'primary'}
              suffixIcon="/icons/arrow_right.svg"
              onClick={() => setCurrentStep('CAPITAL TYPES')}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-1 justify-center">
        <Image
          src="/create_sr.png"
          alt="Supplier Request Image"
          priority
          width={512}
          height={584}
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};
